<template>
  <div
    v-if="shouldShowBar"
    class="category-list bg-grey pb-4 d-none d-sm-flex"
    :style="isSticky ? 'position: sticky;' : 'position: static;'"
  >
    <!-- Preloader state -->
    <template v-if="!categories">
      <div
        v-for="n in indexCount" :key="n"
        class="flex-grow-1 category-list-card pl d-flex align-items-center"
        style="height: 100px; pointer-events: none;"
      >
        <div class="mb-2 mt-2 pl_m--i" style="width: 50%; height: 32px;" />
        <div class="mb-2 pl_m--i" style="width: 50%; height: 24px" />
        <div class="mb-2 pl_m--i" style="width: 50%; height: 12px" />
      </div>
    </template>
    <template v-else>
      <template v-for="{ name, icon, total, tooltip } in categories">
        <component
          :is="'router-link'"
          class="flex-grow-1 category-list-card d-flex align-items-center"
          :key="name"
          :class="{
            'active': activeIndex === name
          }"
          v-tooltip.bottom="tooltip"
          :to="getCategoryLink(name)"
        >
          <i class="category-list-icon my-2" :class="icon" />
          <span class="t-xxlr t-600 mb-2 category-list-count">{{ total | formatNumberShort }}</span>
          <span class="mb-2 px-1 t-xxs text-center category-list-name">{{ getIndexAsString(name) }}</span>
        </component>
      </template>

    </template>
  </div>
</template>

<script>
import { ICONS } from '@/assets/js/_data'
import { getCategoryLink } from '@/plugins/utils'

export default {
  name: 'barSearchCategories',
  props: {
    indexes: {
      type: Object,
      required: false
    },
    activeIndex: {
      type: String,
      required: false
    },
    routeName: {
      type: String,
      required: false
    },
    isSticky: {
      type: Boolean,
      required: false,
      default: true
    },
    indexCount: {
      type: Number,
      required: false,
      default: 8
    },
    showEmptyBar: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    getCategoryLink (category) {
      return getCategoryLink(this.searchView(category), this.$route, category, this.routeName)
    }
  },
  computed: {
    shouldShowBar () {
      if (this.showEmptyBar || !this.categories) return true

      const hasTotal = this.categories.find(c => c.total > 0)
      return !!hasTotal
    },
    categories () {
      if (!this.indexes || this.isEmpty(this.indexes)) return null

      return Object.entries(this.indexes).map(([key, value]) => {
        return {
          name: key,
          icon: ICONS[key],
          total: value.total,
          order: value.order,
          tooltip: value.description
        }
      }).sort((a, b) => a.order - b.order)
    }
  }
}
</script>
